import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "overlay", "placement", "withPortal", "closeOverlay"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { physicalDirectionWarning } from "../../deprecationWarnings";
import { deprecatedOverlayDirections, mapPhysicalToLogicalDirections } from "../../styles/mixins";
import { OverlayPortal } from "../OverlayPortal";
import { Overlay } from "./Overlay";
import { Trigger } from "./Trigger";
var OverlayTriggerComponent = /*#__PURE__*/React.forwardRef(function OverlayTriggerComponent(_ref, ref) {
  var children = _ref.children,
      overlay = _ref.overlay,
      placement = _ref.placement,
      withPortal = _ref.withPortal,
      closeOverlay = _ref.closeOverlay,
      props = _objectWithoutProperties(_ref, _excluded);

  if (placement) {
    physicalDirectionWarning(placement);
  }

  return /*#__PURE__*/React.createElement(Trigger, Object.assign({}, props, {
    ref: ref
  }), children, overlay && (withPortal && typeof ref !== 'function' && ref != null && ref.current ? /*#__PURE__*/React.createElement(OverlayPortal, {
    overlayPosition: ref.current.getBoundingClientRect(),
    closeOverlay: closeOverlay
  }, /*#__PURE__*/React.createElement(Overlay, {
    placement: mapPhysicalToLogicalDirections(placement)
  }, overlay)) : /*#__PURE__*/React.createElement(Overlay, {
    placement: mapPhysicalToLogicalDirections(placement)
  }, overlay)));
});

var overlayTriggerHelpers = _objectSpread({}, deprecatedOverlayDirections);
/**
* **OverlayTrigger** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/OverlayTrigger) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-overlaytrigger--stateful-example) | [Encore](https://encore.spotify.net/web/components/non-visual?format=figma-figma#overlaytrigger) | 
*
* null
*
* @example
* () => {
*  const [isActiveTop, toggleActiveTop] = useState(false);
*  const [isActiveTopRight, toggleActiveTopRight] = useState(false);
*  const [isActiveTopLeft, toggleActiveTopLeft] = useState(false);
*  const [isActiveLeft, toggleActiveLeft] = useState(false);
*  const [isActiveLeftTop, toggleActiveLeftTop] = useState(false);
*  const [isActiveLeftBottom, toggleActiveLeftBottom] = useState(false);
*  const [isActiveBottom, toggleActiveBottom] = useState(false);
*  const [isActiveBottomLeft, toggleActiveBottomLeft] = useState(false);
*  const [isActiveBottomRight, toggleActiveBottomRight] = useState(false);
*  const [isActiveRight, toggleActiveRight] = useState(false);
*  const [isActiveRightTop, toggleActiveRightTop] = useState(false);
*  const [isActiveRightBottom, toggleActiveRightBottom] = useState(false);
*
*  return (
*    <Table>
*      <caption>Different overlay placements</caption>
*      <tbody>
*        <TableRow>
*          <TableCell>
*            <OverlayTrigger
*              placement={OverlayTrigger.topLeft}
*              overlay={
*                isActiveTopLeft && (
*                  <Tooltip>Aenean lacinia bibendum nulla sed consectetur. Cras justo.</Tooltip>
*                )
*              }
*            >
*              <ButtonTertiary
*                condensed
*                aria-expanded={isActiveTopLeft}
*                onClick={() => toggleActiveTopLeft(!isActiveTopLeft)}
*                buttonSize="sm"
*              >
*                Toggle top left
*              </ButtonTertiary>
*            </OverlayTrigger>
*          </TableCell>
*          <TableCell align="center">
*            <OverlayTrigger
*              placement={OverlayTrigger.top}
*              overlay={
*                isActiveTop && (
*                  <Tooltip>Aenean lacinia bibendum nulla sed consectetur. Cras justo.</Tooltip>
*                )
*              }
*            >
*              <ButtonTertiary
*                condensed
*                aria-expanded={isActiveTop}
*                onClick={() => toggleActiveTop(!isActiveTop)}
*                buttonSize="sm"
*              >
*                Toggle top
*              </ButtonTertiary>
*            </OverlayTrigger>
*          </TableCell>
*          <TableCell align="right">
*            <OverlayTrigger
*              placement={OverlayTrigger.topRight}
*              overlay={
*                isActiveTopRight && (
*                  <Tooltip>Aenean lacinia bibendum nulla sed consectetur. Cras justo.</Tooltip>
*                )
*              }
*            >
*              <ButtonTertiary
*                condensed
*                aria-expanded={isActiveTopRight}
*                onClick={() => toggleActiveTopRight(!isActiveTopRight)}
*                buttonSize="sm"
*              >
*                Toggle top right
*              </ButtonTertiary>
*            </OverlayTrigger>
*          </TableCell>
*        </TableRow>
*        <TableRow>
*          <TableCell>
*            <OverlayTrigger
*              placement={OverlayTrigger.leftTop}
*              overlay={
*                isActiveLeftTop && (
*                  <Tooltip>Aenean lacinia bibendum nulla sed consectetur. Cras justo.</Tooltip>
*                )
*              }
*            >
*              <ButtonTertiary
*                condensed
*                aria-expanded={isActiveLeftTop}
*                onClick={() => toggleActiveLeftTop(!isActiveLeftTop)}
*                buttonSize="sm"
*              >
*                Toggle left top
*              </ButtonTertiary>
*            </OverlayTrigger>
*          </TableCell>
*          <TableCell>&nbsp;</TableCell>
*          <TableCell align="right">
*            <OverlayTrigger
*              placement={OverlayTrigger.rightTop}
*              overlay={
*                isActiveRightTop && (
*                  <Tooltip>Aenean lacinia bibendum nulla sed consectetur. Cras justo.</Tooltip>
*                )
*              }
*            >
*              <ButtonTertiary
*                condensed
*                aria-expanded={isActiveRightTop}
*                onClick={() => toggleActiveRightTop(!isActiveRightTop)}
*                buttonSize="sm"
*              >
*                Toggle right top
*              </ButtonTertiary>
*            </OverlayTrigger>
*          </TableCell>
*        </TableRow>
*        <TableRow>
*          <TableCell>
*            <OverlayTrigger
*              placement={OverlayTrigger.left}
*              overlay={
*                isActiveLeft && (
*                  <Tooltip>Aenean lacinia bibendum nulla sed consectetur. Cras justo.</Tooltip>
*                )
*              }
*            >
*              <ButtonTertiary
*                condensed
*                aria-expanded={isActiveLeft}
*                onClick={() => toggleActiveLeft(!isActiveLeft)}
*                buttonSize="sm"
*              >
*                Toggle left
*              </ButtonTertiary>
*            </OverlayTrigger>
*          </TableCell>
*          <TableCell>&nbsp;</TableCell>
*          <TableCell align="right">
*            <OverlayTrigger
*              placement={OverlayTrigger.right}
*              overlay={
*                isActiveRight && (
*                  <Tooltip>Aenean lacinia bibendum nulla sed consectetur. Cras justo.</Tooltip>
*                )
*              }
*            >
*              <ButtonTertiary
*                condensed
*                aria-expanded={isActiveRight}
*                onClick={() => toggleActiveRight(!isActiveRight)}
*                buttonSize="sm"
*              >
*                Toggle right
*              </ButtonTertiary>
*            </OverlayTrigger>
*          </TableCell>
*        </TableRow>
*        <TableRow>
*          <TableCell>
*            <OverlayTrigger
*              placement={OverlayTrigger.leftBottom}
*              overlay={
*                isActiveLeftBottom && (
*                  <Tooltip>Aenean lacinia bibendum nulla sed consectetur. Cras justo.</Tooltip>
*                )
*              }
*            >
*              <ButtonTertiary
*                condensed
*                aria-expanded={isActiveLeftBottom}
*                onClick={() => toggleActiveLeftBottom(!isActiveLeftBottom)}
*                buttonSize="sm"
*              >
*                Toggle left bottom
*              </ButtonTertiary>
*            </OverlayTrigger>
*          </TableCell>
*          <TableCell>&nbsp;</TableCell>
*          <TableCell align="right">
*            <OverlayTrigger
*              placement={OverlayTrigger.rightBottom}
*              overlay={
*                isActiveRightBottom && (
*                  <Tooltip>Aenean lacinia bibendum nulla sed consectetur. Cras justo.</Tooltip>
*                )
*              }
*            >
*              <ButtonTertiary
*                condensed
*                aria-expanded={isActiveRightBottom}
*                onClick={() => toggleActiveRightBottom(!isActiveRightBottom)}
*                buttonSize="sm"
*              >
*                Toggle right bottom
*              </ButtonTertiary>
*            </OverlayTrigger>
*          </TableCell>
*        </TableRow>
*        <TableRow>
*          <TableCell>
*            <OverlayTrigger
*              placement={OverlayTrigger.bottomLeft}
*              overlay={
*                isActiveBottomLeft && (
*                  <Tooltip>Aenean lacinia bibendum nulla sed consectetur. Cras justo.</Tooltip>
*                )
*              }
*            >
*              <ButtonTertiary
*                condensed
*                aria-expanded={isActiveBottomLeft}
*                onClick={() => toggleActiveBottomLeft(!isActiveBottomLeft)}
*                buttonSize="sm"
*              >
*                Toggle bottom left
*              </ButtonTertiary>
*            </OverlayTrigger>
*          </TableCell>
*          <TableCell align="center">
*            <OverlayTrigger
*              placement={OverlayTrigger.bottom}
*              overlay={
*                isActiveBottom && (
*                  <Tooltip>Aenean lacinia bibendum nulla sed consectetur. Cras justo.</Tooltip>
*                )
*              }
*            >
*              <ButtonTertiary
*                condensed
*                aria-expanded={isActiveBottom}
*                onClick={() => toggleActiveBottom(!isActiveBottom)}
*                buttonSize="sm"
*              >
*                Toggle bottom
*              </ButtonTertiary>
*            </OverlayTrigger>
*          </TableCell>
*          <TableCell align="right">
*            <OverlayTrigger
*              placement={OverlayTrigger.bottomRight}
*              overlay={
*                isActiveBottomRight && (
*                  <Tooltip>Aenean lacinia bibendum nulla sed consectetur. Cras justo.</Tooltip>
*                )
*              }
*            >
*              <ButtonTertiary
*                condensed
*                aria-expanded={isActiveBottomRight}
*                onClick={() => toggleActiveBottomRight(!isActiveBottomRight)}
*                buttonSize="sm"
*              >
*                Toggle bottom right
*              </ButtonTertiary>
*            </OverlayTrigger>
*          </TableCell>
*        </TableRow>
*      </tbody>
*    </Table>
*  );
*};
*
*/


export var OverlayTrigger = Object.assign(OverlayTriggerComponent, overlayTriggerHelpers);
export default OverlayTrigger;